import React from 'react';
import google from '../../images/integrations/google.svg';
import IntegrationBot from '../../components/integrationn/index';

const Google = () => <IntegrationBot botLogo={google} botName={'Google'} />;

export default Google;
